import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import './ChurchMedia.css';

function ChurchMedia() {

  return (
    <div className="page-content">
      <h2>教會影視</h2>
      <p>點擊以下按鈕前往教會 YouTube 網站:</p>
      <Link to="https://youtube.com/@hocsf234/featured" target="_new">
            <button className='button button-xl'>
                <FontAwesomeIcon icon={faYoutube} size="1x" /> &nbsp;YouTube 頻道
            </button>
        </Link>
    </div>
  );
}

export default ChurchMedia;
